import type { ReactNode } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs: { label: string; to?: string }[];
  extra?: ReactNode;
}

export default function PageHeader({ eyebrow, title, description, crumbs, extra }: PageHeaderProps) {
  return (
    <section className="bg-primary-900">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
        <div className="[&_a]:text-primary-200 [&_a:hover]:text-accent-400 [&_span]:text-background-50 [&_i]:text-primary-300">
          <Breadcrumb items={crumbs} />
        </div>
        {eyebrow && (
          <span className="mt-5 block font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
            {eyebrow}
          </span>
        )}
        <h1 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-4xl">{title}</h1>
        {description && <p className="mt-3 max-w-3xl text-sm leading-relaxed text-primary-100 md:text-base">{description}</p>}
        {extra && <div className="mt-6">{extra}</div>}
      </div>
    </section>
  );
}